import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';

import { AssignedFlowsActions, AvailableFlowsActions } from '@recruitee/requisitions-data';

@Injectable()
export class RequisitionFlowResolver {
  constructor(private store: Store) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requisitionId = route.parent?.params.id;

    this.store.dispatch(AvailableFlowsActions.fetchOne({ payload: { id: requisitionId } }));
    this.store.dispatch(AssignedFlowsActions.fetch({ payload: { requisitionId } }));

    return true;
  }
}
